import { Middleware } from "@nuxt/types"

const hasVerifiedAccount: Middleware = async ({ store, app, redirect, route }) => {
  const { path } = route
  const { dispatch, getters } = store
  const { currentUser } = getters

  if (!path.includes('/apply')) {
    return
  }

  if (!currentUser) {
    return redirect(app.localePath('account-create'))
  }

  await dispatch('user/account/fetchAccount')
  const { emailVerified } = getters['user/account/account']

  if (!emailVerified) {
    // return redirect(app.localePath('account-verify-resend'))
    return
  }

  return
}

export default hasVerifiedAccount
